import angular from 'angular';
import mycrmPopover from './mycrmPopover';
import mycrmPopoverBody from './mycrmPopoverBody';
import './style.scss';

export default angular
  .module('components.mycrmPopover', [])
  .component('mycrmPopoverBody', mycrmPopoverBody)
  .component('mycrmPopover', mycrmPopover).name;
